export default function SchoolBranding() {
  const benefits = [
    {
      title: 'Competitive Differentiation',
      icon: 'ri-trophy-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://readdy.ai/api/search-image?query=Modern%20school%20building%20with%20STEM%20innovation%20hub%20signage%2C%20prestigious%20educational%20institution%20exterior%2C%20professional%20architecture%20with%20technology%20focus%2C%20bright%20daylight%20setting&width=600&height=400&seq=school-branding-001&orientation=landscape',
      description: 'Position your school as a forward-thinking institution that prepares students for the future.',
      benefits: [
        'Stand out in competitive admissions market',
        'Attract quality students and parents',
        'Premium positioning in the community',
        'Modern infrastructure showcase'
      ]
    },
    {
      title: 'Parent Confidence',
      icon: 'ri-parent-line',
      color: 'from-green-500 to-green-600',
      image: 'https://readdy.ai/api/search-image?query=Happy%20parents%20reviewing%20student%20progress%20on%20tablet%20with%20teacher%2C%20parent-teacher%20meeting%20in%20modern%20school%2C%20transparent%20communication%20and%20satisfaction%2C%20professional%20educational%20setting&width=600&height=400&seq=parent-confidence-001&orientation=landscape',
      description: 'Build trust with transparent progress tracking and regular communication about student achievements.',
      benefits: [
        'Real-time progress tracking portal',
        'Regular student showcases and exhibitions',
        'Future-ready curriculum assurance',
        'Industry connections and opportunities'
      ]
    },
    {
      title: 'Media & Recognition',
      icon: 'ri-award-line',
      color: 'from-purple-500 to-purple-600',
      image: 'https://readdy.ai/api/search-image?query=School%20principal%20receiving%20innovation%20award%20at%20ceremony%2C%20media%20coverage%20of%20educational%20excellence%2C%20professional%20award%20presentation%20with%20trophy%2C%20prestigious%20recognition%20event&width=600&height=400&seq=media-recognition-001&orientation=landscape',
      description: 'Gain visibility and recognition as an innovation leader in education.',
      benefits: [
        'National and regional award opportunities',
        'Press coverage and media features',
        'Educational board recognition',
        'Innovation hub status certification'
      ]
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Elevate Your School's Brand as a STEM Innovation Leader
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto">
            Transform your institution&apos;s reputation and attract the best students with cutting-edge STEM education
          </p>
        </div>

        {/* Benefits Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all border border-gray-200"
            >
              {/* Image */}
              <div className="h-64 overflow-hidden">
                <img
                  src={benefit.image}
                  alt={benefit.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-all duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-8">
                <div className={`w-16 h-16 bg-gradient-to-br ${benefit.color} rounded-xl flex items-center justify-center mb-4 shadow-lg`}>
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{benefit.description}</p>

                <ul className="space-y-3">
                  {benefit.benefits.map((item, bIdx) => (
                    <li key={bIdx} className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-500 text-xl flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Statistics Panel */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-12 text-center text-white">
          <h3 className="text-2xl font-bold mb-10">Impact on School Performance</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { number: '40%', label: 'Average Enrollment Increase', icon: 'ri-user-add-line' },
              { number: 'Top 10', label: 'Ranking in District', icon: 'ri-medal-line' },
              { number: '25+', label: 'Featured in Publications', icon: 'ri-newspaper-line' }
            ].map((stat, idx) => (
              <div key={idx} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6">
                <i className={`${stat.icon} text-3xl mb-3 block`}></i>
                <div className="text-3xl font-bold mb-1">{stat.number}</div>
                <div className="text-sm text-blue-100">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}